import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import CommonImagePreview from '../components/CommonImagePreview';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

const ATTACH_FILE_CONTENT_URL = `api/master/attach_files/files`;
class DataTableCommonDataEnterprise extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageUrls: {} 
        };
    }

    componentDidMount() {
        this.loadImages();
    }
    
    componentDidUpdate(prevProps) {
        const prevRows = prevProps.DataTable?.rows || [];
        const currentRows = this.props.DataTable?.rows || [];
    
        const hasChanged = prevRows.length !== currentRows.length ||
            prevRows.some((prevRow, i) => {
                const currRow = currentRows[i];
                return prevRow.id !== currRow.id ||
                       prevRow.logo_file_id !== currRow.logo_file_id;
            });
    
        if (hasChanged) {
            this.loadImages();
        }
    }

    loadImages = async () => {
        const { DataTable } = this.props;
        const imageUrls = await Actions.loadImageBlobUrls({
            rows: DataTable.rows,
            fileField: "logo_file_id",
            idField: "id",
            baseUrl: ATTACH_FILE_CONTENT_URL
        });
        this.setState({ imageUrls });
    };

    render() {

        let props = this.props;

        let { onSetEdit, onPreviewFile, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, Masterbase, UserCookie} = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row.user_rows === 0 && row.status !== '0') { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-100p"></th>
                                        <th className="th-width-auto"></th>
                                        <th className="th-width-150p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {

                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                        
                                        rowId++;

                                        let del = true;
                                        if (row.user_rows > 0 || row.status === '0') { del = false; }

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {!util.isEmpty(row.logo_file_id) && (
                                                            <CommonImagePreview
                                                                src={this.state.imageUrls?.[row.id] || null}
                                                                width={80}
                                                                height={80}
                                                                alt="โลโก้"
                                                            />
                                                        )}
                                                    </td>                                                    
                                                    <td title={row.operator_name}>
                                                        {row.operator_name} 
                                                        <br></br>

                                                        <p className="title-xs mt-1 mb-0">
                                                            <i className="fa-classic fa-light fa-location-dot fa-fw me-2"></i>
                                                            {util.formatThaiAddress(
                                                                {
                                                                    address: row.location,
                                                                    province_name: row.province_name,
                                                                    district_name: row.district_name,
                                                                    subdistrict_name: row.subdistrict_name,
                                                                    zip_code: row?.zip_code
                                                                }
                                                            )}
                                                        </p>

                                                        {(row.coordinator_name || row.coordinator_phone_number) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                {row.coordinator_name && <><i className="fa-classic fa-light fa-user-headset fa-fw me-2"></i>ผู้ประสานงาน {row.coordinator_name}<span className="me-2"></span></>}
                                                                {row.coordinator_phone_number && <><i className="fa-classic fa-light fa-phone fa-fw me-2"></i>เบอร์ติดต่อ {row.coordinator_phone_number}</>}
                                                            </p>
                                                        )}
                                                        
                                                        <Badge className="badge-md me-1 mt-2"  bg="primary" pill>{row.benefits_name}</Badge>
                                                    </td>
                                                    <td>
                                                        <CommonDropdown
                                                            element="DataTable"
                                                            input={{id: 'status', value: row.status}}
                                                            option={{source: 'options', section: 'status', item: 'default'}}
                                                            callback={(e, element) => onDropDownChange(e, element, {key: 'id', value: row.id} )} 
                                                            disabled={!['0', '1'].includes(UserCookie.types)}
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {['0', '1', '3'].includes(UserCookie.types) && (
                                                            <CommonButton 
                                                                task="edit" 
                                                                rounded={false}
                                                                disabled={false}
                                                                callback={(e) => onSetEdit(e, {id: row.id})} 
                                                            />
                                                        )} 
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableCommonDataEnterprise;
